const Disziplinenverwaltung: React.FC = () => {
  return <></>;
};

export default Disziplinenverwaltung;
